import React from 'react'
import KeywordIdeasForm from './KeywordIdeasForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function KeywordIdeas() {
  SetTitle('Keyword Ideas')
  const description =
    'Una volta caricato il file viene ritornato alla mail specificata il report finale. Questo report contiene, per ogni keyword fornita una lista di keyword suggerite (ideas) con il loro relativo volume complessivo e il volume medio dei mesi dell\'ultimo anno (relativo a google.com)'

  return (
    <Header
      iconClass="fa-solid fa-lightbulb fa-xl"
      title="Keyword Ideas"
      docLink="/docs/ranking_tools/keyword-ideas/"
      description={description}
    >
      <KeywordIdeasForm />
    </Header>
  )
}